import { render } from "./TwoFaPin.vue?vue&type=template&id=ce15ddca&scoped=true"
import script from "./TwoFaPin.vue?vue&type=script&lang=js"
export * from "./TwoFaPin.vue?vue&type=script&lang=js"

import "./TwoFaPin.vue?vue&type=style&index=0&id=ce15ddca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce15ddca"]])

export default __exports__